import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';

const CheckOutCart = (props) => {

    const BorderRadius = {
        upperBorderRadius: "10px 10px 0px 0px",
        noBorderRadius: "0px",
        lowerBorderRadius: "0px 0px 10px 10px",
        borderRadius: "10px"
    }

    const BackgroundColor = {
        cadet: "#36686A",
        white: "#F3F3F3",
        black: "#000000"
    }

    const CheckoutContainer = styled.div.attrs((props) => ({
        variant : props
    }))`
    padding: 25px 0 25px 20px;
    background: ${({variant}) => BackgroundColor[variant.background]};
    border-radius: ${({variant}) => BorderRadius[variant.borderRadius]};
    color: ${({variant}) => BackgroundColor[variant.color]};
    `

    return (
        <section className="checkout-cart m-2">
            <CheckoutContainer className="row" borderRadius={props.borderRadius} background={props.background} color={props.color ? props.color: "black"}>
                <div className="col-xs-8 col-lg-7 font-medium-x-large">
                    <div className="d-flex flex-column">
                        <h3 className={`font-medium-x-large m-0 color-black bold`}>
                            {props.title}
                        </h3>
                        <div className="font-medium-x-large color-black light">
                            {props.device}
                        </div>
                    </div>
                </div>
                {   props.showQuantity ?
                    <div className="col-xs-4 col-lg-2 d-flex flex-row">
                        <div className="square-small" onClick={() => props.updateCart('remove')}>
                            <div className="px-3 py-2">
                                <i className="icon-minus" />
                            </div>
                        </div>
                        <div className="square-small">
                            <div className="px-3 py-2">
                                {props.quantity}
                            </div>
                        </div>
                        <div className="square-small" onClick={() => props.updateCart('add')}>
                            <div className="px-3 py-2">
                                <i className="icon-plus" />
                            </div>
                        </div>
                    </div> : ''
                }
                <div className={`col-xs-12 ${!props.showQuantity ? "col-lg-5": "col-lg-3"} text-right pr-lg-3 font-x-large m-0`}>
                    <h3 className="font-size-30 m-0 medium-bold pr-lg-3">
                        {props.showQuantity ? '$' + (props.quantity * props.upFrontPrice): props.price}
                    </h3>
                    <div className="col-xs-12 mt-2 pr-2 pr-lg-3 text-right font-tiny light">
                        {props.promotion}
                    </div>
                </div>

            </CheckoutContainer>
        </section>
    );
}

CheckOutCart.propTypes = {
    quantity: PropTypes.number,
    upFrontPrice: PropTypes.number
};

export default CheckOutCart;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/orderSummary/CheckOutCart.js